import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import { Headline as BaseHeadline } from "../typography";
export var Headline = styled(BaseHeadline).withConfig({
  componentId: "sc-1ym17v-0"
})(["grid-column:1 / -1;text-align:center;margin:0 0 44px;", ";", ";", ";"], mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 0 72px;\n  "]))))), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 4 / 10;\n  "]))))), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 5 / 9;\n    margin: 0 -32px 80px -32px;\n  "]))))));
export var Section = styled.section.withConfig({
  componentId: "sc-1ym17v-1"
})(["max-width:100%;overflow-x:hidden;"]);